export default __webpack_public_path__ + "static/media/client30.2667e42a.png";